export default __webpack_public_path__ + "static/media/talent-main-section-client-use-upwork-Dev-IT.b8fdbae3.png";